import { render, staticRenderFns } from "./AboutDetail.vue?vue&type=template&id=261b206a&scoped=true"
import script from "./AboutDetail.vue?vue&type=script&lang=js"
export * from "./AboutDetail.vue?vue&type=script&lang=js"
import style0 from "./AboutDetail.vue?vue&type=style&index=0&id=261b206a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261b206a",
  null
  
)

export default component.exports